var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CruResource',{attrs:{"done-route":_vm.doneRoute,"mode":_vm.mode,"resource":_vm.value,"validation-passed":_vm.valid,"errors":_vm.errors,"can-yaml":false},on:{"finish":_vm.save}},[_c('GlobalRoleBindings',{ref:"grb",attrs:{"group-principal-id":_vm.value.id,"mode":_vm.mode},on:{"canLogIn":function($event){_vm.valid = $event}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }